


























































































import dayjs from 'dayjs';
import toFloat from '@/lib/toFloat.ts';
import * as math from 'mathjs';
import {Component, Vue, Watch} from 'vue-property-decorator';


@Component
export default class Statistics extends Vue {
  public monthPicker = '';
  public fold = false;

  get currentMonth() {
    const currentMonth = parseInt(this.formatDate(this.monthPicker).split('-')[1], 10);
    return currentMonth;
  }

  // @Watch('monthPicker')
  get monthData() {
    if (!this.monthPicker) {
      return;
    }

    const monthFilter = this.$store.state.tallyRecord.filter((item: RecordItem) => {
      return item.date.indexOf(this.formatDate(this.monthPicker)) > -1;
    }).sort((item1: RecordItem, item2: RecordItem) => {
      return dayjs(item2.date).valueOf() - dayjs(item1.date).valueOf();
    });


    const currentMonth = {} as any;
    for (const item of monthFilter) {
      const arr = [];
      arr.push(item);
      if (currentMonth.hasOwnProperty(item.date)) {
        currentMonth[item.date].today.push(item);
      } else {
        currentMonth[item.date] = {};
        currentMonth[item.date].today = arr;
      }
      currentMonth[item.date].name = item.date;
    }
    for (const obj of Object.keys(currentMonth)) {
      let earn = 0;
      let pay = 0;
      for (const item of currentMonth[obj].today) {
        if (item.type === 'earn') {
          earn = Number(this.exactingFloat(Number(earn + Number(item.amount))));
        } else if (item.type === 'pay') {
          pay = Number(this.exactingFloat(Number(pay + Number(item.amount))));
        }
      }

      currentMonth[obj].count = toFloat(Number(this.exactingFloat(earn - pay)));
      currentMonth[obj].earn = toFloat(earn);
      currentMonth[obj].pay = toFloat(pay);

    }

    return currentMonth;
  }

  get monthCount() {
    const monthCount = {
      count: 0,
      earn: 0,
      pay: 0,
    };
    let result = {};

    for (const obj of Object.keys(this.monthData)) {
      monthCount.count = Number(this.exactingFloat(monthCount.count + Number(this.monthData[obj].count)));
      monthCount.earn = Number(this.exactingFloat(monthCount.earn + Number(this.monthData[obj].earn)));
      monthCount.pay = Number(this.exactingFloat(monthCount.pay + Number(this.monthData[obj].pay)));
    }
    result = {
      count: toFloat(monthCount.count),
      earn: toFloat(monthCount.earn),
      pay: toFloat(monthCount.pay),
    };
    return result;
  }


  public beforeMount() {
    this.monthPicker = this.formatDate('');
    this.$store.commit('fetchTags');
    this.$store.commit('fetchRecord');

  }

  public formatDate(date: string) {
    let formated = '';
    if (!date) {
      formated = dayjs().format('YYYY-MM');
    } else {
      formated = dayjs(date).format('YYYY-MM');
    }
    return formated;
  }

  public exactingFloat(value: number) {
    const precision = 14;
    return math.format(value, precision);
  }

}
